import React, { useState } from 'react';
import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  SxProps,
} from '@mui/material';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IconWrapper } from '../../elements/IconWrapper/Index';
import getDeviceType from '../../../commonUtils/getDeviceType';
interface IProps {
  value: string;
  onChange: (value: string) => void;
  optionsList: IOptionList[];
  isEditing?: boolean;
  isIconInside?: boolean;
  iconName?: string;
  customStyles?: SxProps;
}
interface IOptionList {
  name: string | number;
  id: number;
  nonEditableItem?: boolean;
  selectedNumber?: number;
}
export const ModeOfConductionDropdown = (props: IProps) => {
  const {
    value,
    onChange,
    optionsList,
    isEditing,
    isIconInside,
    iconName,
    customStyles,
  } = props;
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };
  const deviceType = getDeviceType();
  const android = window.Android;
  const handleOpen = () => {
    try {
      if (deviceType === 'android' && android?.disableAppRefresh) {
        console.log('App refresh disabled on Android for home page');
        android.disableAppRefresh();
      }
    } catch (error) {
      console.error(
        'An error occurred while attempting to disable app refresh on Android:',
        error
      );
    }
  };

  const handleClose = () => {
    try {
      if (deviceType === 'android' && android?.enableAppRefresh) {
        console.log('App refresh enabled on Android for home page');
        android.enableAppRefresh();
      }
    } catch (error) {
      console.error(
        'An error occurred while attempting to enable app refresh on Android:',
        error
      );
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: pxToRem(10), md: pxTovW(13) },
        alignItems: 'center',
      }}
    >
      {!isIconInside ? (
        <IconWrapper
          name={iconName ? iconName : 'clicker_icon'}
          type="png"
          parentFolder="icons"
          customSx={{
            width:
              iconName === 'mobile-app'
                ? { xs: pxToRem(40), md: pxTovW(65), lg: pxTovW(60) }
                : { xs: pxToRem(29), md: pxTovW(55), lg: pxTovW(41) },
            height:
              iconName === 'mobile-app'
                ? { xs: pxToRem(46), md: pxTovW(75), lg: pxTovW(65) }
                : { xs: pxToRem(46), md: pxTovW(75), lg: pxTovW(65) },
            marginY: 'auto',
          }}
        />
      ) : (
        <></>
      )}
      {isEditing ? (
        <Select
          value={value}
          onChange={(e) => {
            handleChange(e);
          }}
          displayEmpty
          onOpen={handleOpen}
          onClose={handleClose}
          renderValue={(value: any) => (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: { xs: pxToRem(5), md: pxTovW(10) },
              }}
            >
              {isIconInside && iconName ? (
                <IconWrapper
                  name={iconName ? iconName : 'clicker_icon'}
                  type="png"
                  parentFolder="icons"
                  customSx={{
                    width: { xs: pxToRem(20), lg: pxTovW(26) },
                    height: { xs: pxToRem(20), lg: pxTovW(42) },
                  }}
                />
              ) : (
                <></>
              )}
              {value}
            </Box>
          )}
          sx={{
            background: '#F5FAFF',
            width: { xs: '100%', md: pxTovW(332) },
            borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
            height: { xs: 'max-content', md: '70%', lg: pxTovW(65) },
            '.MuiOutlinedInput-notchedOutline': { borderColor: '#007CDC' },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#007CDC',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#007CDC',
            },
            boxShadow: 'none',
            ...customStyles,
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: { xs: pxToRem(150), md: pxTovW(300) },
                minHeight: { xs: 'max-content', md: 'max-content' },
                backgroundColor: '#F8FCFF',
                '&::-webkit-scrollbar': { display: 'none' },
                padding: 0,
                borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
                '& .MuiList-root': {
                  backgroundColor: '#F8FCFF',
                  maxHeight: { xs: pxToRem(150), md: pxTovW(300) },
                  padding: 0,
                },
                scrollbarWidth: 'thin',
                minWidth: { xs: '95%', md: pxTovW(230) },
                maxWidth: { xs: '95%', md: pxTovW(200), lg: pxTovW(150) },
              },
            },
          }}
        >
          {optionsList.map((option) => (
            <MenuItem key={option.id} value={option.name}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Box
          sx={{
            fontWeight: 'bold',
            border: '1px solid #007CDC',
            borderRadius: '4px',
            padding: '8px 12px',
            background: '#F5FAFF',
          }}
        >
          {value}
        </Box>
      )}
    </Box>
  );
};
